// extracted by mini-css-extract-plugin
export default {"container":"WritePad_container__j+txN","writeArea":"WritePad_writeArea__8YQ-W","submit":"WritePad_submit__0ynkv","btn":"WritePad_btn__fORMI"};